import { useEffect } from 'react';

export const useDynamicSEO = () => {
  useEffect(() => {
    const fetchSEO = async () => {
      try {
        const response = await fetch('/api/seo-settings');
        const data = await response.json();
        
        // Update title
        document.title = data.site_title || 'girgit | Half Eaten Donut';
        
        // Update meta description
        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
          metaDesc = document.createElement('meta');
          metaDesc.name = 'description';
          document.head.appendChild(metaDesc);
        }
        metaDesc.content = data.site_description || 'Internal portal for Half Eaten Donut';
        
        // Update keywords
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (!metaKeywords) {
          metaKeywords = document.createElement('meta');
          metaKeywords.name = 'keywords';
          document.head.appendChild(metaKeywords);
        }
        metaKeywords.content = data.keywords || 'girgit, half eaten donut';
        
        // Update favicon
        if (data.favicon_url) {
          let favicon = document.querySelector('link[rel="icon"]');
          if (!favicon) {
            favicon = document.createElement('link');
            favicon.rel = 'icon';
            document.head.appendChild(favicon);
          }
          favicon.href = data.favicon_url;
        }
      } catch (error) {
        console.error('Failed to load SEO settings');
      }
    };
    
    fetchSEO();
    
    // Listen for SEO updates
    const handleSEOUpdate = () => fetchSEO();
    window.addEventListener('seo-updated', handleSEOUpdate);
    
    return () => window.removeEventListener('seo-updated', handleSEOUpdate);
  }, []);
};
